import { Draft } from 'immer';

import { TAccountTypeGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { CreditAgreementFullArtifact } from '~/core/routes/settings/implementations/common/types';

export const tAccountToLabel: Record<
  Extract<TAccountTypeGQLType, 'unusedInterestExpense'>,
  string
> = {
  unusedInterestExpense: 'Unused Fee',
};

export const deleteExpense = (
  draft: Draft<CreditAgreementFullArtifact>,
  counterpartySlug: string,
  tAccount: Extract<TAccountTypeGQLType, 'unusedInterestExpense'>,
) => {
  if (draft.liabilityAccounts) {
    draft.liabilityAccounts = draft.liabilityAccounts.filter(
      (liabilityAccount) =>
        liabilityAccount.counterpartySlug !== counterpartySlug &&
        liabilityAccount.tAccount !== tAccount,
    );
  }
};
